import React from 'react';
import PropTypes from "prop-types";

import styles from "./table.scss";

function Table({ children, variant }) {
    return (
        <div className={`${styles.dataTable} ${styles[variant]}`}>{children}</div>/* add variant class "sticky_header" for sticky table header  */
    )
}

Table.defaultProps = {
    variant: 'sticky_header'
}

Table.propTypes = {
    variant: PropTypes.oneOf(['sticky_header', 'default'])
}
 
export default Table;